<template>
  <div class="visitorInfo" @scroll="handleScroll" ref="scrollContainer"
    :style="{ paddingBottom: ifPend ? '120px' : '0' }">
    <div v-if="sourceIsH5" class="navBar-wrap">
      <NavBar :opacity="isAtTop" :narBarTitle="isAtTop ? '' : $t('来访详情')" />
    </div>
    <div class="title">
      {{ $t('邀请 ') }}<span class="title-text">{{ info.visitorName }}</span>{{ $t(' 来访详情') }}
    </div>
    <div class="info-card">
      <Card :title="$t('访客信息')" :status="status">
        <div class="content">
          <div class="content-icon">
            <img src="@/assets/images/visitorIcon.svg" alt="" />
          </div>
          <p class="content-name">{{ info.visitorName }}</p>
          <div class="visitor">
            <div class="content-visitPurpose">{{ I18nTemplateForRender(info.visitPurpose) }}</div>
            <div v-if="visitAcceptedStatus" class="content-accept">
              {{ $t('接受邀约') }}
            </div>
          </div>
        </div>
        <div class="content">
          <div class="content-icon">
            <img src="@/assets/images/mobileIcon.svg" alt="" />
          </div>
          <p class="content-title">{{ getSecretPhone(info.visitorMobile) }}</p>
        </div>
        <div class="content">
          <div class="content-icon">
            <img src="@/assets/images/companyIcon.svg" alt="" />
          </div>
          <p class="content-title">
            {{ $t('所属 ') }}{{ info.visitorCompany || '/' }}
          </p>
        </div>
        <div class="content">
          <div class="content-icon">
            <img src="@/assets/images/visitorIcon.svg" alt="" />
          </div>
          <p class="content-title">
            {{ $t('到访') }}{{ info.visitorNumber }}{{ $t('人') }}
          </p>
        </div>
      </Card>
      <Card v-if="
        visitStatus !== 'pend' &&
        visitStatus !== 'refuse' &&
        visitStatus !== 'cancel'
      " :title="$t('预约信息')" :buttonTitle="this.visitStatus !== 'completed' && this.visitStatus !== 'cancel'
        ? $t('复制邀约信息')
        : null
        " @button-click="copyInviteInfo">
        <div class="content">
          <div class="content-icon">
            <img src="@/assets/images/invitationCodeIcon.svg" alt="" />
          </div>
          <p class="content-title">
            {{ $t('预约码 ') }}{{ info.invitationCode }}
          </p>
        </div>
        <div class="content-code" @click="showCode = true">
          <div class="code-title">
            <div class="content-icon">
              <img src="@/assets/images/QR-Icon.svg" alt="" />
            </div>
            <p class="content-title">{{ $t('预约二维码') }}</p>
          </div>
          <div class="form-icon">
            <img src="@/assets/images/form-icon.svg" alt="" />
          </div>
        </div>
      </Card>
      <Card :title="$t('接待人信息')">
        <div class="content">
          <div class="content-icon">
            <img src="@/assets/images/visitorIcon.svg" alt="" />
          </div>
          <p class="content-title">{{ user.companyId == 303 ? info.interviewee : info.intervieweeName }}</p>
        </div>
        <div class="content">
          <div class="content-icon"><img src="@/assets/images/addressIcon.svg" alt="" /></div>
          <div class="content-title-address">{{ info.address }}</div>
        </div>
      </Card>
      <DateRangePicker :startTime="info.visitTime" :endTime="info.visitEndTime" :isClickable="false" />
      <Card :title="$t('接待方式')">
        <div class="content">
          <div class="content-icon">
            <img src="@/assets/images/addressIcon.svg" alt="" />
          </div>
          <p class="content-title">{{ registerMode }}</p>
        </div>

        <div class="content">
          <div class="content-icon">
            <img src="@/assets/images/timeIcon.svg" alt="" />
          </div>
          <p class="content-title">
            {{
              info?.createdTime &&
              dayjs(info?.createdTime).format('YYYY/MM/DD HH:mm:ss')
            }}{{ $t('提交申请') }}
          </p>
        </div>
      </Card>
    </div>

    <van-popup v-model="showCode" round>
      <div class="signIn-box">
        <div class="signIn-code">
          <vue-qr :text="info.invitationCode" :size="qrSize" :margin="0" ref="qrCode" class="code"></vue-qr>
        </div>
        <div class="signIn-font">{{ $t('签到二维码') }}</div>
      </div>
    </van-popup>
    <div v-if="ifPend" class="operation">
      <div @click.stop="onRefuse" class="rejectDestine">
        {{ $t('拒绝来访') }}
      </div>
      <div @click.stop="checkRepeat" class="editDestine">
        {{ $t('同意来访') }}
      </div>
    </div>
  </div>
</template>
<script>
import { getCompanyInfo, getVisit, getRobotWork } from '@/services/api'
import DateRangePicker from '@/components/DateRangePicker'
import NavBar from '@/components/newNavBar'
import Card from '@/components/newCard'
import dayjs from 'dayjs'
import vueQr from 'vue-qr'
import Vue from 'vue'
import { Popup, Toast } from 'vant'
import { visitAudit } from '@/services/api'
import { I18nTemplateForRender } from 'i18n'

Vue.use(Popup)
Vue.use(Toast)

export default {
  name: 'VisitorInfo',
  components: {
    NavBar,
    vueQr,
    Card,
    DateRangePicker,
  },
  data() {
    return {
      user: {},
      visitStatus: '',
      showRobot: false,
      info: {},
      robotName: '',
      serial: '',
      showcanTime: false,
      visitId: '',
      showLink: false,
      sourceIsH5: true,
      defaultPhoto: require('@/assets/images/default_visitPhoto.png'),
      status: '',
      registerMode: this.$t('签到后呼叫接待人'),
      ifPre: false,
      showCode: false,
      qrSize: 200,
      visitAcceptedStatus: '',
      customText: '',
      companyName: '',
      invitaUrl: null,
      ifPend: false,
      isAtTop: true,
      approveLoading: false,
      refuseLoading: false,
    }
  },
  methods: {
    getSecretPhone(phone) {
      if (!phone) {
        return
      }
      return phone.replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2')
    },
    I18nTemplateForRender(payload) {
      // 可在此处做一层安全包装或兼容性处理
      try {
        return I18nTemplateForRender(payload)
      } catch (e) {
        // 出错时返回原始值，避免页面崩溃
        console.warn('I18nTemplateForRender error:', e)
        return payload
      }
    },
    handleScroll(event) {
      if (event.target.scrollTop <= 44) {
        this.isAtTop = true
      } else {
        this.isAtTop = false
      }
    },
    copyInviteInfo() {
      const textarea = document.createElement("textarea");
      textarea.style = { opacity: 0, height: 0, lineHeight: 0, fontSize: 0 }
      textarea.value = this.$t(
        '{slot1} 您好！',
        {
          slot1: this.info.visitorName,
          slot2: this.companyName,
          slot3: this.info.intervieweeName,
          slot4: this.formatVisitTime,
          // slot5: this.info.visitTime,
          // slot6:
          //   this.info.visitEndTime &&
          //   `-${dayjs(this.info.visitEndTime).format('HH:mm')}`,
          slot7: this.info.address,
          slot8: this.info.smsUrl,
          slot9:
            this.info.visitAcceptedStatus == 'awaiting'
              ? this.$t('接受预约')
              : '',
          slot10: this.info.invitationCode,
        }
      );
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      Toast.success(this.$t('邀约信息已复制'))
    },
    toRobot() {
      this.$router.push({
        name: 'LinkRobot',
        query: {
          serial: this.serial,
          robotName: this.robotName,
          visitId: this.visitId,
          registerTime: this.info.registerTime,
          token: this.user.token,
          mobile: this.user.mobile,
          id: this.user.id,
          developerId: this.user.companyId,
        },
      })
    },
    async getInfo(id) {
      let res
      if (!this.$route.query.data) {
        res = await getVisit({ id })
      } else {
        res = JSON.parse(this.$route.query.data)
      }
      this.visitAcceptedStatus = res.visitAcceptedStatus == 'awaiting'
      res.visitDate = dayjs(res.visitTime).format('YYYY-MM-DD')
      // res.visitTime = dayjs(res.visitTime).format('HH:mm')
      this.info = { ...res, smsUrl: res.smsUrl }
      console.log(this.info)

      this.visitStatus = res.status
      if (this.visitStatus == 'pend') {
        this.status = this.$t('审批中')
        if (this.isApproval(res, this.user.id) === 1) {
          this.ifPend = true
        } else {
          this.ifPend = false
        }
      } else {
        this.ifPend = false
      }
      if (this.visitStatus == 'refuse') {
        this.status = this.$t('已拒绝')
        this.ifPend = false
      }
      if (this.visitStatus == 'pre') {
        this.status = this.$t('预接待')
        this.ifPre = true
      }
      if (this.visitStatus == 'cancel') {
        this.status = this.$t('已取消')
        this.showcanTime = true
      }
      if (window.injectData && window.injectData.source == 'NewWorkApp') {
        this.sourceIsH5 = false
      }
      if (this.visitStatus == 'in') {
        this.status = this.$t('接待中')
        this.robotName = this.info.registerRobotName
        this.serial = this.info.registerRobot
        this.visitId = this.info.id
        // this.showLink = true
        this.showRobot = true
      }
      if (this.visitStatus == 'completed') {
        this.status = this.$t('已完成')
        this.robotName = this.info.registerRobotName
        this.serial = this.info.registerRobot
        this.visitId = this.info.id
        this.showRobot = true
      }
      if (res.registerMode) {
        switch (res.registerMode) {
          case '':
            this.registerMode = this.$t('签到后呼叫接待人')
            break
          case 'noGuide':
            this.registerMode = this.$t('签到后直接开门')
            break
          case 'pointGuide':
            this.registerMode =
              this.$t('签到引领到目的地') +
              '/' +
              res.robotLocation +
              this.$t('点位')
            break
          case 'routeGuide':
            this.getLocation(res.robotGuide)
            break
        }
      }
      let companyCode = JSON.parse(localStorage.getItem('cCode')).code
      const resLogo = await getCompanyInfo(companyCode)
      this.companyName = resLogo.shortName || resLogo.name || ''

      // const inviteInfo = `【NewWork】${this.info.visitorName} 您好！上海新柏石的${
      //   this.info.intervieweeName
      // }邀请您来访。\n\n时间：${this.info.visitDate} ${this.info.visitTime}${
      //   this.info.visitEndTime && `-${dayjs(this.info.visitEndTime).format('HH:mm')}`
      // }
      // \n\n地址：${this.info.address}\n\n点击：${res.smsUrl} ${
      //   this.info.visitAcceptedStatus == 'awaiting' ? '接受预约' : ''
      // }\n\n请您抵达后在机器人/智能屏上输入预约码或是扫描二维码签到，机器人/智能屏将为您服务。\n\n预约码：${
      //   this.info.invitationCode
      // }`
      // this.invitaUrl = inviteInfo
    },
    async getLocation(id) {
      const res = await getRobotWork(this.user.companyId)
      if (res.robotGuideName) {
        res.robotGuideName.split(',').forEach((item) => {
          if (item.split(':')[0] == id) {
            this.registerMode =
              this.$t('签到后进行讲解') +
              '/' +
              item.split(':')[1] +
              this.$t('路线')
          }
        })
      }
    },
    isApproval(data, id) {
      if (data.shareId) {
        if (data.auditProcess == 0 && id == data.interviewee) {
          return 1
        } else if (
          data.auditProcess == 1 &&
          data.auditStaffId?.split(',').includes(id + '')
        ) {
          return 1
        }
      } else {
        if (data.auditStaffId?.split(',').includes(id + '')) {
          return 1
        }
      }
      return 2
    },
    async checkRepeat() {
      if (this.approveLoading) return
      try {
        this.approveLoading = true
        await visitAudit({
          id: this.$route.params.id || this.$route.query.id,
          opinion: 'agree',
        })
        this.getInfo(this.$route.params.id || this.$route.query.id)
        Toast(this.$t('审批已通过'))
      } catch (error) {
        console.log(error)
      } finally {
        this.approveLoading = false
      }
    },
    async onRefuse() {
      if (this.refuseLoading) return
      try {
        this.refuseLoading = true
        await visitAudit({
          id: this.$route.params.id || this.$route.query.id,
          opinion: 'refuse',
        })
        this.getInfo(this.$route.params.id || this.$route.query.id)
        Toast(this.$t('审批已拒绝'))
      } catch (error) {
        console.log(error)
      } finally {
        this.refuseLoading = false
      }
    },
  },
  computed: {
    // 格式化来访时间，优先使用 finishTime
    formatVisitTime() {
      if (!this.info.visitTime) return ''

      const startTime = dayjs(this.info.visitTime)
      const endTime = this.info.finishTime
        ? dayjs(this.info.finishTime)
        : (this.info.visitEndTime ? dayjs(this.info.visitEndTime) : null)

      if (!endTime) {
        return startTime.format('YYYY-MM-DD HH:mm')
      }

      // 判断是否跨天
      // const isSameDay = startTime.format('YYYY-MM-DD') === endTime.format('YYYY-MM-DD')

      // if (isSameDay) {
      //   // 同一天，显示格式：YYYY-MM-DD HH:mm-HH:mm
      //   return `${startTime.format('YYYY-MM-DD HH:mm')}-${endTime.format('HH:mm')}`
      // } else {
      //   // 跨天，显示完整日期时间：YYYY-MM-DD HH:mm - YYYY-MM-DD HH:mm
      //   return `${startTime.format('YYYY-MM-DD HH:mm')} - ${endTime.format('YYYY-MM-DD HH:mm')}`
      // }
      return `${startTime.format('YYYY-MM-DD HH:mm')} - ${endTime.format('YYYY-MM-DD HH:mm')}`
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.getInfo(this.$route.params.id || this.$route.query.id)
    this.qrSize = 200 * (window.screen.width / 375)
  },
}
</script>
<style lang="less" scoped>
.visitorInfo {
  min-height: 100vh;
  max-height: 90vh;
  overflow-y: auto;
  width: 100%;
  position: relative;
  background: linear-gradient(180deg, #c6dffe 0%, #f3f7fb 100%);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  padding: 0 12px;
  padding-bottom: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  .navBar-wrap {
    width: 100%;
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
  }

  .title {
    width: 100%;
    height: 40px;
    padding-left: 12px;
    margin-bottom: 18px;
    margin-top: 62px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #1e2329;
    line-height: 40px;
    text-align: left;
    font-style: normal;
    z-index: 1;

    .title-text {
      display: inline-block;
      vertical-align: middle;
      max-width: 140px;
      height: 40px;
      margin-bottom: 6px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #1e2329;
      line-height: 40px;
      font-style: normal;
      white-space: nowrap;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .info-card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    z-index: 1;
    gap: 12px;
    margin-bottom: 30px;

    .content-code {
      width: 100%;
      min-width: 303px;
      box-sizing: border-box;
      height: 40px;
      padding-left: 24px;
      padding-right: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .code-title {
        display: flex;
        align-items: center;
      }

      .content-title {
        height: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #1e2329;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }


      .content-icon {
        min-width: 16px;
        min-height: 16px;
        width: 16px;
        height: 16px;
        box-sizing: border-box;
        margin-right: 12px;

        img {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
        }
      }

      .form-icon {
        width: 20px;
        height: 20px;
      }
    }

    .content {
      width: 100%;
      min-width: 303px;
      box-sizing: border-box;
      height: auto;
      min-height: 40px;
      padding: 0 24px;
      display: flex;
      align-items: center;

      .content-icon {
        min-width: 16px;
        min-height: 16px;
        width: 16px;
        height: 16px;
        box-sizing: border-box;
        margin-right: 12px;

        img {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
        }
      }

      .visitor {
        height: 100%;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: 6px;

        .content-visitPurpose {
          flex-shrink: 0;
          padding: 0 4px;
          height: 18px;
          background: #ffe4c4;
          border-radius: 2px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #ac7a3c;
          line-height: 18px;
          text-align: center;
          font-style: normal;
        }

        .content-accept {
          flex-shrink: 0;
          padding: 0 4px;
          height: 18px;
          background: #c4e7ff;
          border-radius: 2px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #3972ff;
          line-height: 18px;
          text-align: center;
          font-style: normal;
        }
      }

      .content-title {
        height: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #1e2329;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .content-name {
        max-width: 110px;
        height: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #1e2329;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .signIn-box {
    width: 296px;
    height: 320px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;

    .signIn-code {
      width: 200px;
      height: 200px;
      margin-top: 40px;
    }

    .signIn-font {
      font-size: 18px;
      margin-top: 25px;
      line-height: 24px;
    }
  }
}

.visitorInfo::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 200px;
  background-image: url('../../../assets/images/visitorBG.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 0;
}

/deep/.van-popup--center.van-popup--round {
  border-radius: 4px;
}

.operation {
  width: 375px;
  height: 72px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(30, 35, 41, 0.1);
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;

  .rejectDestine {
    width: 160px;
    height: 48px;
    background: #f6465d;
    border-radius: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 48px;
    text-align: center;
    font-style: normal;
    margin-right: 16px;
  }

  .editDestine {
    width: 160px;
    height: 48px;
    background: #167aff;
    border-radius: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 48px;
    text-align: center;
    font-style: normal;
  }
}

.content-title-address {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #1e2329;
  line-height: 24px;
  font-style: normal;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  box-orient: vertical;
}
</style>
